export default {"src":"/_next/static/media/logo-white.e822c13b.svg","height":50,"width":332,"blurWidth":0,"blurHeight":0};